import PropTypes from 'prop-types';
import React, { FC } from 'react';
import BreadcrumbsWidget from '../breadcrumbs-widget';
import DesktopHeader from '../desktop-header';
import HeaderTabs from '../header-tabs/header-tabs.component';
import { areBreadcrumbsVisible } from '../header-tabs';
import { connect } from '../../../common/components/runtime-context';
import { flowRight } from 'lodash';
import { RootState } from '../../reducers/root-state';
import styles from './internal-page-tabs-header.scss';
import Breadcrumbs from '../../components/breadcrumbs';
import SearchInputSuggestions from '../../components/search-input-suggestions';
import { encodeQuery } from '../../services/query-encoding';

interface InternalPageTabsDesktopHeaderProps {
  params: any;
  routes: any;
  customCtaLabel: string;
  areBreadcrumbsVisible: boolean;
  onSearch: (query: string) => void;
  onSearchFocus: () => void;
  onSearchClear: () => void;
  searchQuery: (query: string) => void;
}

const InternalPageTabsDesktopHeader: FC<InternalPageTabsDesktopHeaderProps> = ({
  params,
  routes,
  areBreadcrumbsVisible,
  onSearch,
  onSearchFocus,
  onSearchClear,
  customCtaLabel,
  ...props
}) => (
  <>
    <DesktopHeader
      className={styles.header}
      removeVerticalSpacing={true}
      removeStartSpacing={true}
      left={<HeaderTabs />}
      right={
        <BreadcrumbsWidget
          searchInput={
            <SearchInputSuggestions
              onSearch={onSearch}
              initialQuery={params.query || ''}
              onFocus={onSearchFocus}
              onClear={onSearchClear}
            />
          }
          params={params}
        />
      }
      {...props}
    />
    {areBreadcrumbsVisible && (
      <DesktopHeader
        className={styles.container}
        size="large"
        left={
          <Breadcrumbs
            className={styles.breadcrumbs}
            routes={routes}
            params={params}
            customCtaLabel={customCtaLabel}
          />
        }
      />
    )}
  </>
);

InternalPageTabsDesktopHeader.propTypes = {
  params: PropTypes.object.isRequired,
};

const mapRuntimeToProps = (state: RootState, _: any, actions: any) => ({
  areBreadcrumbsVisible: areBreadcrumbsVisible(state),
  onSearch: (query: string) =>
    actions.navigateWithinForum(`/search${query ? `/${encodeQuery(query)}` : ''}`),
  onSearchFocus: actions.userEventsSearchFocused,
  onSearchClear: actions.userEventsSearchCleared,
});

export default flowRight(connect(mapRuntimeToProps))(InternalPageTabsDesktopHeader);
